const AppEnvironment = {
  Production: 'prod',
  ProductionUs: 'prod-us',
  Development: 'dev',
} as const;

// Both production deploys: EU (`prod`) and US (`prod-us`).
export const isProduction = () =>
  window._env_.VITE_APP_ENVIRONMENT === AppEnvironment.Production ||
  window._env_.VITE_APP_ENVIRONMENT === AppEnvironment.ProductionUs;

const isDevelopment = () => window._env_.VITE_APP_ENVIRONMENT === AppEnvironment.Development;

// Assuming that any other value for VITE_APP_ENVIRONMENT represents the local environment
export const isLocal = () => !isProduction() && !isDevelopment();

export const isTest = () => process.env?.VITEST === 'true';

export const isEmbedded = () => window.self !== window.top;

export const isE2ESession = () => typeof window !== 'undefined' && window.__E2E_TEST__ === true;
